import {IRoutableModule} from '../../router/routing.infra';
import {InvitationEndedView} from './view';
import {invitationEndedRouteLoader} from './invitation-ended.loader';

export default {
    loader: invitationEndedRouteLoader,
    Component: InvitationEndedView,
    storeAs: 'invitationEndedStore'
} as IRoutableModule;
